import { groupByToMap, stringComparerBy } from "@entrilia/shared/utilities/arrayHelper";
import type { ArtifactRow } from "./artifactRow";
import type { ArtifactsTileSort } from "./artifactsListView";

export interface ArtifactTileGroup {
  groupId: string;
  label: string;
  rows: ArtifactRow[];
}

const compareNames = stringComparerBy((row: ArtifactRow) => row.name);

const toTileGroups = (rows: ArtifactRow[], isGroupSelected: boolean): ArtifactTileGroup[] =>
  isGroupSelected
    ? [{ groupId: "", label: "", rows }]
    : [...groupByToMap(rows, (row) => row.groupId).entries()].map(([groupId, groupRows]) => ({
        groupId,
        label: groupRows[0].group,
        rows: groupRows,
      }));

export const groupArtifactTiles = (
  rows: ArtifactRow[],
  sort: ArtifactsTileSort,
  isGroupSelected: boolean
): ArtifactTileGroup[] => {
  const groups = toTileGroups(rows, isGroupSelected);
  return sort === "name" ? groups.map((group) => ({ ...group, rows: [...group.rows].sort(compareNames) })) : groups;
};
